class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new window.PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 0.5,
      maxZoomLevel: 'fill',
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,

      closeOnVerticalDrag: true,

      tapAction: 'zoom',

      pswpModule: () => {
        return window.PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('afterInit', () => {
      this.setupDialogLabel()
      this.setupCarouselA11y()
      this.moveTopBarFirst()
      this.moveCloseButtonFirst()
    })

    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
    })
  }

  setupDialogLabel () {
    const pswpEl = this.photoSwipeInstance?.pswp?.element
    if (!pswpEl) return

    pswpEl.setAttribute('role', 'dialog')
    pswpEl.setAttribute('aria-modal', 'true')

    const scrollWrap = pswpEl.querySelector('.pswp__scroll-wrap')
    if (!scrollWrap) return

    const dialogLabel =
      this.dataset.pswpDialogLabel || window.theme?.strings?.mediaGallery || ''

    let headingEl = scrollWrap.querySelector('[data-pswp-dialog-heading]')

    if (!headingEl) {
      headingEl = document.createElement('h2')
      headingEl.className = 'util-ScreenReaderOnly'
      headingEl.setAttribute('data-pswp-dialog-heading', 'true')
      headingEl.textContent = dialogLabel
      scrollWrap.prepend(headingEl)
    }

    if (!headingEl.id) {
      headingEl.id = `pswp-dialog-title-${Date.now()}`
    }

    if (!headingEl.textContent) {
      headingEl.textContent = dialogLabel
    }

    pswpEl.setAttribute('aria-labelledby', headingEl.id)

    if (dialogLabel) {
      pswpEl.setAttribute('aria-label', dialogLabel)
    }
  }

  setupCarouselA11y () {
    const scrollWrap = this.photoSwipeInstance?.pswp?.scrollWrap

    if (!scrollWrap) return

    const zoomCarouselLabel = 'zoom carousel'

    scrollWrap.setAttribute('role', 'region')
    scrollWrap.setAttribute('aria-label', zoomCarouselLabel)

    if (scrollWrap.querySelector('[data-pswp-carousel-instructions]')) return

    const instructionsEl = document.createElement('p')

    instructionsEl.className = 'util-ScreenReaderOnly'
    instructionsEl.setAttribute('data-pswp-carousel-instructions', 'true')
    instructionsEl.textContent =
      'Carousel. Use left and right arrow keys to navigate between slides.'

    scrollWrap.append(instructionsEl)
  }

  moveTopBarFirst () {
    const pswpEl = this.photoSwipeInstance?.pswp?.element
    if (!pswpEl) return

    const scrollWrap = pswpEl.querySelector('.pswp__scroll-wrap')
    if (!scrollWrap) return

    const topBar = scrollWrap.querySelector('.pswp__top-bar')
    if (!topBar) return

    scrollWrap.prepend(topBar)
  }

  moveCloseButtonFirst () {
    const pswpEl = this.photoSwipeInstance?.pswp?.element
    if (!pswpEl) return

    const topBar = pswpEl.querySelector('.pswp__top-bar')
    if (!topBar) return

    const closeBtn = pswpEl.querySelector('.pswp-Action_Close')
    if (!closeBtn) return

    topBar.prepend(closeBtn)
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        const totalItems = pswp.getNumItems()

        for (let i = 0; i < totalItems; i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.setAttribute('aria-label', `image ${i + 1} of ${totalItems}`)
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.alt = ''
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  get closeSvg () {
    return '<span class="util-ScreenReaderOnly fz-10_150">Close</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7 17.5L17.5 7" stroke="black"/><path d="M7 7L17.5 17.5" stroke="black"/></svg>'
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
